import React from "react";
import styled from "styled-components";
import { floatToPercent } from "../utils/format";

import {
  Table,
  Td,
  TdWithTooltip,
  Th,
  TableHeaderRow,
  HeaderGrouping
} from "./SetiTable.styled";

const Tr = props => {
  const { buckets, version, totalPitches, nameFontWeight, name } = props;
  const strikePct = buckets.map((d, i) => {
    const value = d.calledStrikePct;
    const totalPitches = d.numCalledBalls + d.numCalledStrikes;
    let color;
    if (value <= 0.4) {
      color = "#bbdefb";
    } else if (value > 0.4 && value < 0.6) {
      color = "#fff59d";
    } else {
      color = "#ef9a9a";
    }
    return (
      <TdWithTooltip
        noborder
        key={i}
        bgcolor={color}
        data-total-pitches-tooltip={`${totalPitches} pitches`}
        highlight
      >
        {floatToPercent(value)}
      </TdWithTooltip>
    );
  });

  return (
    <tr>
      <Td textAlignment={"left"} fontWeight={nameFontWeight}>
        {name}
      </Td>
      <Td>{version}</Td>
      <Td>{totalPitches}</Td>
      {strikePct}
    </tr>
  );
};

const createTableHeaders = (data, i) =>
  data.map((e, i) => <Th key={i}>{e}</Th>);

const createColgroup = (data, color) =>
  data.length > 0 ? <Colgroup color={color} span={data.length} /> : null;

const createHeaderGrouping = (data, color, title) =>
  data.length > 0 ? (
    <HeaderGrouping colSpan={data.length} backgroundColor={color}>
      {title}
    </HeaderGrouping>
  ) : null;

const Colgroup = styled.colgroup`
  border: 3px solid
    ${props => {
      switch (props.color) {
        case "darkRed":
          return props.theme.darkRed;
        case "brown":
          return props.theme.brown;
        default:
          return props.theme.green;
      }
    }};
`;

const TableWrapper = styled.div`
  margin-top: 40px;
  overflow-x: scroll;
`;

const Tfoot = styled.tfoot`
  background: ${props => props.theme.lightGray};
`;

class SetiTable extends React.Component {
  render() {
    const { setiData: data } = this.props;
    const leftBallZone = createTableHeaders(data.leftAutoBall);
    const leftQuestionableZone = createTableHeaders(data.leftQuestionable);
    const strikeZone = createTableHeaders(data.autoStrike);
    const rightQuestionableZone = createTableHeaders(data.rightQuestionable);
    const rightBallZone = createTableHeaders(data.rightAutoBall);

    return (
      <TableWrapper>
        <Table width="1550px" compact>
          <colgroup>
            <col width={"11%"} />
            <col width={"4%"} />
            <col width={"4%"} />
          </colgroup>
          {createColgroup(data.leftAutoBall, "darkRed")}
          {createColgroup(data.leftQuestionable, "brown")}
          {createColgroup(data.autoStrike, "green")}
          {createColgroup(data.rightQuestionable, "brown")}
          {createColgroup(data.rightAutoBall, "darkRed")}
          <thead>
            <tr>
              <th colSpan="3" />
              {createHeaderGrouping(
                data.leftAutoBall,
                "rgba(132, 0, 7, 0.25)",
                "Ball Zone"
              )}
              {createHeaderGrouping(
                data.leftQuestionable,
                "rgba(130, 85, 8, 0.25)",
                "Buffer Zone"
              )}
              {createHeaderGrouping(
                data.autoStrike,
                "rgba(17, 132, 44, 0.25)",
                "Strike Zone"
              )}
              {createHeaderGrouping(
                data.rightQuestionable,
                "rgba(130, 85, 8, 0.25)",
                "Buffer Zone"
              )}
              {createHeaderGrouping(
                data.rightAutoBall,
                "rgba(132, 0, 7, 0.25)",
                "Ball Zone"
              )}
            </tr>
            <TableHeaderRow>
              <Th textAlignment={"left"}>Name</Th>
              <Th>V#</Th>
              <Th>Pitches</Th>
              {leftBallZone}
              {leftQuestionableZone}
              {strikeZone}
              {rightQuestionableZone}
              {rightBallZone}
            </TableHeaderRow>
          </thead>
          <tbody>
            {data.records.map((v, i) => (
              <Tr
                key={i}
                buckets={v.buckets}
                version={v.version}
                totalPitches={v.totalPitches}
                name={v.name}
              />
            ))}
          </tbody>
          <Tfoot>
            <Tr buckets={data.totals} name={"Totals"} nameFontWeight={"600"} />
          </Tfoot>
        </Table>
      </TableWrapper>
    );
  }
}

export default SetiTable;



// WEBPACK FOOTER //
// ./src/components/SetiTable.js